import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Title from "../components/Title"
import Layout from "../components/Layout"
import Seo from "../components/Seo"

const Conditions = () => {
  return (
    <Layout>
      <Seo title="Condiciones" />
      <Container>
        <section className="img-wrapper">
          <div className="overlay"></div>
          <Title title="Condiciones" className="title-absolute" />
          <StaticImage
            src="../assets/images/condiciones-hero.jpg"
            layout="constrained"
            className="img"
            alt="condiciones"
          />
        </section>
        <section className="info section section-center">
          <h3>Requisitos y documentos necesarios para el arriendo:</h3>
          <ul>
            <li>Edad mínima para arrendar 23 años.</li>
            <li>
              Cédula de Identidad o Pasaporte válidamente emitido y vigente al
              momento del arriendo del vehículo.
            </li>
            <li>
              Licencia de Conducir vigente al momento del término del arriendo y
              válida para conducir vehículo.
            </li>
            <li>Tarjeta de crédito en garantía.</li>
          </ul>
          <div className="conditions-center">
            <h3>CONDICIONES DEL CONTRATO DE ARRIENDO</h3>
            <h4>1. Garantía del Arriendo:</h4>
            <p>
              Todos los arriendos de vehículos requieren una garantía de Tarjeta
              de Crédito, con un cupo mínimo de $ 500.000 o 18 UF. Este monto
              dependerá de la categoría del vehículo y los días de arriendo
              solicitados. Para garantizar el arriendo solamente se acepta
              tarjeta de crédito; MasterCard, Visa, Diner Club, American
              Express. No se aceptan Cheques ni otro documento que no sea
              Tarjeta de Crédito para garantizar el arriendo.
            </p>
            <h4>2. Incluido en la tarifa:</h4>
            <p>
              Tarifa incluye T/km + Cobertura Básica (CDW y DAT), cobertura CDW
              con deducible.
            </p>
            <p>
              El día de arriendo de un vehículo contempla 24 horas
              contabilizadas desde la hora de inicio del contrato. Loki Rent a
              Car Puerto Montt entrega a sus clientes 1 hora de gracia para la
              devolución del vehículo, sin recargo adicional; luego de este
              plazo se considerará 1 día adicional.
            </p>
            <h4>3. Condiciones de uso:</h4>
            <p>
              El cliente destinará el vehículo para su propio uso o para quienes
              este designe como conductores adicionales, estándole prohibido
              subarrendarlo y utilizarlo para un uso comercial o para cualquier
              otro distinto al establecido en las condiciones particulares o
              generales. El cliente deberá utilizar el vehículo de acuerdo a las
              características que este lo permite según las especificaciones y
              recomendaciones del fabricante, terrenos inadecuados, para
              remolcar otros vehículos y para cualquier uso para el que no esté
              especificado el vehículo. El cliente se obliga a cuidar
              adecuadamente el vehículo, revisando periódicamente sus niveles de
              aceite, agua, hidráulicos y en general a velar por el cuidado,
              mantención y correcto funcionamiento del vehículo. El cliente
              deberá comunicar de cualquier avería o desperfecto a la
              arrendadora y no podrá realizar reparaciones por sí mismo. Las
              reparaciones deberán realizarse en servicio técnico o taller
              mecánico autorizado por la arrendadora, previo acuerdo escrito de
              esta.
            </p>
            <h4>4. Responsabilidades y riesgos del contrato</h4>
            <p>
              El cliente será el único responsable por los daños y perjuicios
              que se irrogue a la arrendadora y a terceros a causa de la
              conducción o uso que realice del vehículo, liberando desde ya de
              toda responsabilidad a la arrendadora. En caso de que la
              arrendadora resulte obligada a pagar cualquier indemnización o
              multa derivadas del uso del vehículo por parte del cliente, podrá
              repetir lo pagado en contra de este y de mandar los perjuicios que
              este le haya ocasionado. El cliente no podrá eximirse de esta
              responsabilidad bajo pretexto de haber sido utilizado el vehículo
              contra su voluntad o sin su consentimiento. Así mismo, el cliente
              asume el riesgo por la tenencia del vehículo, siendo de su cargo
              todos los daños que ha este le ocurra, incluido los daños a los
              accesorios, parabrisas, neumáticos, perdida de las llaves, etc. El
              cliente será así mismo responsable por cualquier infracción a la
              ley del tránsito durante la tenencia del mismo.
            </p>
          </div>
        </section>
      </Container>
    </Layout>
  )
}

export default Conditions

const Container = styled.div`
  .img-wrapper {
    width: 100%;
    height: 408px;
    position: relative;
    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1));
      z-index: 1;
    }
    .img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    padding: 5rem 12px;
  }

  li {
    color: var(--black);
    list-style-type: auto;
  }

  .info {
    h3 {
      text-align: center;
      font-size: 1.3rem;
      margin: 2rem 0;
      text-transform: uppercase;
      color: var(--grey-900);
    }
  }

  h4 {
    text-transform: none;
    color: var(--grey-700);
  }

  p {
    letter-spacing: var(--letterSpacing);
    color: var(--grey-500);
    max-width: 1000px;
  }

  @media (min-width: 992px) {
    .info {
      h3 {
        margin: 4rem 0;
        font-size: 1.953rem;
      }
    }
  }
`
